class SectionTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupValues()
  }

  setupListeners () {
    super.setupListeners()

    this.debouncedOnResize = window.BAO.Utils.debounce(() => {
      this.setupValues()
    }, 200)

    window.addEventListener('resize', this.debouncedOnResize)
  }

  setupValues () {
    let itemWidths = 0

    this.els.item.elements.forEach((element) => {
      itemWidths += element.offsetWidth
    })

    this.style.setProperty('--Speed', `${itemWidths * 0.025}s`)

    const containerWidth = this.els.track.element.offsetWidth
    const proportion = (itemWidths / containerWidth) * 100

    this.style.setProperty('--Translate', `-${proportion * 2}%`)
  }
}

if (!customElements.get('section-ticker')) {
  customElements.define('section-ticker', SectionTicker)
}
